import { render, staticRenderFns } from "./Visit-Listing-Template.vue?vue&type=template&id=ecbf8fa4"
import script from "./Visit-Listing-Template.vue?vue&type=script&lang=js"
export * from "./Visit-Listing-Template.vue?vue&type=script&lang=js"
import style0 from "./Visit-Listing-Template.vue?vue&type=style&index=0&id=ecbf8fa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports